var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGptPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_18895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2724 28.1483C69.2724 45.6121 54.8475 59.7643 37.0615 59.7643C19.2756 59.7643 4.85072 45.6058 4.85072 28.1483C4.85072 18.0449 8.15456 10.2284 15.4688 6.17326C20.7906 3.21785 28.8433 2.67426 36.3422 2.67426C43.8411 2.67426 51.4864 2.96167 57.0692 5.82961C64.9245 9.86597 69.2787 17.9387 69.2787 28.1483H69.2724Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4313 59.6956C19.1673 59.6956 5.12445 45.8183 5.12445 28.7606C5.12445 20.3005 8.5174 12.4027 14.6731 6.52316C20.3641 1.0872 52.4985 1.08095 58.1959 6.52316C64.3516 12.4027 67.7446 20.3068 67.7446 28.7606C67.7446 45.8183 53.7017 59.6956 36.4377 59.6956H36.4313ZM36.4313 2.89919C26.0742 2.89919 17.4613 4.47999 14.9914 6.84182C8.92481 12.6402 5.58278 20.4255 5.58278 28.7669C5.58278 45.5809 19.422 59.2582 36.4377 59.2582C53.4534 59.2582 67.2926 45.5809 67.2926 28.7669C67.2926 20.4255 63.9506 12.6402 57.884 6.84182C55.4141 4.47999 46.7948 2.89919 36.4377 2.89919H36.4313Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7084 54.4158C26.2524 58.8771 34.5089 60.8828 42.9371 59.3707C55.2549 57.1651 64.5235 48.0739 67.4454 36.8396C66.0385 34.0591 63.5177 31.7473 60.6531 30.3477C56.3626 28.2545 51.4227 27.8671 46.6293 27.9171C41.3457 27.9796 35.9921 28.5419 31.0841 30.4726C26.1761 32.4033 21.7327 35.8149 19.3965 40.4698C17.213 44.8248 17.143 50.3045 19.7148 54.4096L19.7084 54.4158Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04806 29.3917C5.04806 16.8827 19.1928 6.74808 36.635 6.74808C54.0773 6.74808 68.2156 16.8827 68.2156 29.3917C68.2156 30.2539 68.1392 31.1099 68.0119 31.9472C69.3933 29.3042 70.1572 26.4363 70.1572 23.4434C70.1572 16.1142 65.6248 9.54729 58.476 5.12354C52.6322 1.51206 19.2628 1.99318 13.2281 6.31071C7.11694 10.6782 3.3293 16.7453 3.3293 23.4434C3.3293 26.2176 3.98497 28.8856 5.18174 31.3661C5.10535 30.7163 5.05442 30.054 5.05442 29.3917H5.04806Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4492 20.5692C23.3369 27.8671 33.4585 32.1097 43.5928 31.941C47.616 31.8722 51.9765 31.2287 55.3759 33.3468C59.1762 35.7149 60.2839 41.0134 58.7115 45.156C57.1392 49.2985 53.4534 52.3602 49.4621 54.3971C38.3092 60.0955 23.7316 58.5647 14.0684 50.6669C6.1748 44.225 2.65453 34.6777 2.57814 24.8305C2.55904 21.9563 1.76969 17.0202 4.62155 15.1395C9.09669 12.184 13.8647 17.8324 16.4555 20.5754L16.4492 20.5692Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.3498 3.53649C54.8666 2.61175 53.1479 2.0994 51.3845 2.05566L45.5853 1.9057H22.5285C18.5117 1.9057 14.6858 3.54899 11.9613 6.42942C6.25119 12.4652 2.83914 20.6379 3.15742 29.6603C3.69215 44.8623 17.3085 59.1707 32.7901 60.8078C52.193 62.8572 68.9859 48.4425 69.7243 29.7228C70.1254 19.4757 64.9373 8.90372 56.3498 3.53649ZM65.1219 29.5479C64.4853 45.6746 50.0223 58.0898 33.3121 56.334C19.0146 54.8282 7.93812 42.9191 7.74715 28.8731C7.65803 22.0562 10.0388 15.8393 14.0493 10.9656C16.4492 8.04771 20.0904 6.37319 23.9226 6.37319H49.0929C52.785 6.37319 56.3244 7.94774 58.6606 10.7407C62.9384 15.8455 65.3956 22.4311 65.1155 29.5479H65.1219Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4447 2.11815C55.987 1.20591 55.3122 0.662311 53.5807 0.556091L53.3961 2.01818H19.6957V0.556091C16.2391 1.02471 13.0244 2.6305 10.6245 5.16729C4.59609 11.5342 0.999427 20.1568 1.33045 29.6728C1.897 45.7058 16.2582 60.8015 32.5864 62.526C53.0524 64.6879 70.7683 49.486 71.5449 29.7353C71.9714 18.9259 66.4969 7.7728 57.4384 2.1119L57.4447 2.11815ZM33.1402 57.8149C18.0597 56.2278 6.37214 43.6626 6.1748 28.8481C6.07931 21.6564 8.59379 15.0957 12.8207 9.95968C15.3542 6.88555 19.0528 6.49191 23.095 6.49191H49.6467C53.5425 6.49191 57.2729 8.15394 59.7428 11.0969C64.2561 16.4828 66.9934 22.0563 66.6942 29.5604C66.0258 46.5681 50.7671 59.6706 33.1402 57.8149Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.8585 1.762C56.2607 0.756036 54.4146 0.206192 52.5176 0.162454L46.2792 0H21.4718C17.1558 0 13.0371 1.7745 10.1025 4.88612C3.95951 11.4155 0.286459 20.2505 0.630211 30.0103C1.20313 46.4493 15.8571 61.92 32.51 63.6882C53.3834 65.9063 71.4494 50.317 72.2452 30.079C72.678 18.9946 67.0953 7.57285 57.8585 1.76825V1.762ZM67.2926 29.8915C66.6115 47.3241 51.0471 60.7515 33.0702 58.8521C17.6841 57.2275 5.76739 44.3437 5.57005 29.1605C5.47457 21.7876 8.03997 15.0645 12.3496 9.80347C14.9341 6.64812 18.8491 4.84238 22.9741 4.84238H50.0541C54.0263 4.84238 57.8331 6.5419 60.3475 9.56604C64.95 15.0832 67.5982 22.2062 67.2926 29.8978V29.8915Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4731 7.16675C72.3279 16.964 74.0467 32.0285 68.0056 43.6502C66.0131 47.5116 63.2631 50.9856 59.9338 53.7723C62.9893 50.7294 65.5611 47.2242 67.3881 43.3565C73.0154 31.741 71.3731 17.4014 63.4668 7.16675H63.4731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8925 59.302C3.55847 51.6604 -3.92132 30.4414 4.52606 13.8086C7.19332 8.46635 11.3056 3.80517 16.3728 0.556091C11.5411 4.09259 7.63893 8.77251 5.14354 14.096C-2.82004 30.5851 4.39875 50.9606 20.8925 59.302Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0749 28.9418C47.0749 24.5118 50.5952 20.9253 54.9366 20.9253C59.2781 20.9253 62.7984 24.518 62.7984 28.9418C62.7984 33.3655 59.2781 36.9583 54.9366 36.9583C50.5952 36.9583 47.0749 33.3655 47.0749 28.9418Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.3313 35.5149C59.6732 35.5149 63.193 32.0601 63.193 27.7984C63.193 23.5366 59.6732 20.0818 55.3313 20.0818C50.9894 20.0818 47.4696 23.5366 47.4696 27.7984C47.4696 32.0601 50.9894 35.5149 55.3313 35.5149Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4096 28.9779C61.0718 26.2239 59.3341 23.4644 56.5283 22.8144C53.7225 22.1644 50.9111 23.87 50.2489 26.624C49.5866 29.378 51.3243 32.1375 54.1301 32.7875C56.9359 33.4375 59.7473 31.7318 60.4096 28.9779Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3661 23.1934C64.8672 27.1486 62.8429 33.528 57.9349 34.9838C62.2254 32.6782 63.9442 27.6047 61.4679 23.3184L61.3661 23.1934Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.671 34.3965C45.3625 31.4098 46.432 22.175 53.377 20.5817C47.1768 22.9685 46.3301 30.7413 51.671 34.3965Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.1235 27.6609C51.1235 25.3803 53.0078 23.5308 55.3313 23.5308C57.6548 23.5308 59.5391 25.3803 59.5391 27.6609C59.5391 29.9415 57.6548 31.791 55.3313 31.791C53.0078 31.791 51.1235 29.9415 51.1235 27.6609Z",
    fill: "url(#paint0_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7936 43.344C37.7936 38.914 41.3139 35.3275 45.6553 35.3275C49.9968 35.3275 53.5171 38.9202 53.5171 43.344C53.5171 47.7677 49.9968 51.3605 45.6553 51.3605C41.3139 51.3605 37.7936 47.7677 37.7936 43.344Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.1883 42.2006C38.1883 37.9393 41.7085 34.484 46.05 34.484C50.3915 34.484 53.9117 37.9393 53.9117 42.2006C53.9117 46.4619 50.3915 49.9171 46.05 49.9171C41.7085 49.9171 38.1883 46.4619 38.1883 42.2006Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1311 43.3769C51.7933 40.6229 50.0556 37.8634 47.2498 37.2134C44.444 36.5634 41.6326 38.2691 40.9704 41.023C40.3082 43.777 42.0459 46.5365 44.8517 47.1865C47.6575 47.8365 50.4689 46.1309 51.1311 43.3769Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0848 37.5894C55.5859 41.5445 53.5616 47.924 48.6536 49.3798C52.9441 47.0742 54.6629 42.0007 52.1866 37.7144L52.0848 37.5894Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3897 48.7987C36.0812 45.8121 37.1507 36.5772 44.0957 34.9839C37.8954 37.3707 37.0424 45.1435 42.3897 48.7987Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.8486 42.0631C41.8486 39.7825 43.7329 37.933 46.0564 37.933C48.3799 37.933 50.2641 39.7825 50.2641 42.0631C50.2641 44.3437 48.3799 46.1932 46.0564 46.1932C43.7329 46.1932 41.8486 44.3437 41.8486 42.0631Z",
    fill: "url(#paint1_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4417 43.344C18.4417 38.914 21.9619 35.3275 26.3034 35.3275C30.6448 35.3275 34.1651 38.9202 34.1651 43.344C34.1651 47.7677 30.6448 51.3605 26.3034 51.3605C21.9619 51.3605 18.4417 47.7677 18.4417 43.344Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.4565 43.4392C35.1522 39.2325 32.2418 35.2687 27.956 34.5859C23.6702 33.9031 19.6319 36.7597 18.9362 40.9664C18.2405 45.1731 21.1509 49.1368 25.4367 49.8196C29.7225 50.5025 33.7608 47.6458 34.4565 43.4392Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7771 43.3751C32.4393 40.6211 30.7016 37.8616 27.8958 37.2116C25.09 36.5616 22.2786 38.2672 21.6164 41.0212C20.9542 43.7752 22.6919 46.5347 25.4977 47.1847C28.3035 47.8347 31.1149 46.1291 31.7771 43.3751Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7328 37.5894C36.234 41.5445 34.2097 47.924 29.3017 49.3798C33.5922 47.0742 35.311 42.0007 32.8347 37.7144L32.7328 37.5894Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0377 48.7987C16.7293 45.8121 17.7987 36.5772 24.7438 34.9839C18.5435 37.3707 17.6969 45.1435 23.0377 48.7987Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.4903 42.0631C22.4903 39.7825 24.3746 37.933 26.6981 37.933C29.0216 37.933 30.9058 39.7825 30.9058 42.0631C30.9058 44.3437 29.0216 46.1932 26.6981 46.1932C24.3746 46.1932 22.4903 44.3437 22.4903 42.0631Z",
    fill: "url(#paint2_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2577 28.9418C28.2577 24.5118 31.7779 20.9253 36.1194 20.9253C40.4609 20.9253 43.9811 24.518 43.9811 28.9418C43.9811 33.3655 40.4609 36.9583 36.1194 36.9583C31.7779 36.9583 28.2577 33.3655 28.2577 28.9418Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.646 27.7984C28.646 23.5371 32.1663 20.0818 36.5077 20.0818C40.8492 20.0818 44.3694 23.5371 44.3694 27.7984C44.3694 32.0596 40.8492 35.5149 36.5077 35.5149C32.1663 35.5149 28.646 32.0596 28.646 27.7984Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5112 32.5335C41.1747 31.4507 42.4395 28.4536 41.3362 25.8393C40.233 23.225 37.1795 21.9836 34.5161 23.0665C31.8526 24.1493 30.5878 27.1464 31.6911 29.7607C32.7943 32.375 35.8478 33.6164 38.5112 32.5335Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5488 23.1934C46.05 27.1486 44.0257 33.528 39.1177 34.9838C43.4082 32.6782 45.127 27.6047 42.6507 23.3184L42.5488 23.1934Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8538 34.3965C26.5453 31.4098 27.6147 22.175 34.5598 20.5817C28.3595 22.9685 27.5129 30.7413 32.8538 34.3965Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.3063 27.6609C32.3063 25.3803 34.1906 23.5308 36.5141 23.5308C38.8376 23.5308 40.7219 25.3803 40.7219 27.6609C40.7219 29.9415 38.8376 31.791 36.5141 31.791C34.1906 31.791 32.3063 29.9415 32.3063 27.6609Z",
    fill: "url(#paint3_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0898 14.1148C21.0898 11.0344 23.5406 8.5351 26.5644 8.5351C29.5881 8.5351 32.0389 11.0344 32.0389 14.1148C32.0389 17.1951 29.5881 19.6944 26.5644 19.6944C23.5406 19.6944 21.0898 17.1951 21.0898 14.1148Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.8317 18.6885C29.8553 18.6885 32.3063 16.2827 32.3063 13.315C32.3063 10.3473 29.8553 7.94153 26.8317 7.94153C23.8082 7.94153 21.3572 10.3473 21.3572 13.315C21.3572 16.2827 23.8082 18.6885 26.8317 18.6885Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2033 13.315C23.2033 11.3468 24.8265 9.74725 26.8381 9.74725C28.8497 9.74725 30.473 11.3406 30.473 13.315C30.473 15.2894 28.8497 16.8827 26.8381 16.8827C24.8265 16.8827 23.2033 15.2894 23.2033 13.315Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0332 10.1096C33.4712 12.8651 32.058 17.3014 28.646 18.3136C31.6315 16.7078 32.8283 13.1775 31.1032 10.1909L31.0332 10.1034V10.1096Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2854 17.9074C19.893 15.833 20.6378 9.39736 25.4758 8.29767C21.1598 9.9597 20.5678 15.3707 24.2854 17.9074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.9035 13.2213C23.9035 11.6342 25.2148 10.3471 26.8317 10.3471C28.4487 10.3471 29.76 11.6342 29.76 13.2213C29.76 14.8083 28.4487 16.0955 26.8317 16.0955C25.2148 16.0955 23.9035 14.8083 23.9035 13.2213Z",
    fill: "url(#paint4_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5118 14.1148C40.5118 11.0344 42.9626 8.5351 45.9864 8.5351C49.0101 8.5351 51.4609 11.0344 51.4609 14.1148C51.4609 17.1951 49.0101 19.6944 45.9864 19.6944C42.9626 19.6944 40.5118 17.1951 40.5118 14.1148Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.2601 18.6885C49.2836 18.6885 51.7346 16.2827 51.7346 13.315C51.7346 10.3473 49.2836 7.94153 46.2601 7.94153C43.2366 7.94153 40.7855 10.3473 40.7855 13.315C40.7855 16.2827 43.2366 18.6885 46.2601 18.6885Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6252 13.315C42.6252 11.3468 44.2485 9.74725 46.2601 9.74725C48.2717 9.74725 49.8949 11.3406 49.8949 13.315C49.8949 15.2894 48.2717 16.8827 46.2601 16.8827C44.2485 16.8827 42.6252 15.2894 42.6252 13.315Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4551 10.1096C52.8932 12.8651 51.48 17.3014 48.068 18.3136C51.0535 16.7078 52.2503 13.1775 50.5252 10.1909L50.4551 10.1034V10.1096Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7138 17.9074C39.3214 15.833 40.0662 9.39736 44.9042 8.29767C40.5882 9.9597 39.9962 15.3707 43.7138 17.9074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.3318 13.2213C43.3318 11.6342 44.6432 10.3471 46.2601 10.3471C47.877 10.3471 49.1883 11.6342 49.1883 13.2213C49.1883 14.8083 47.877 16.0955 46.2601 16.0955C44.6432 16.0955 43.3318 14.8083 43.3318 13.2213Z",
    fill: "url(#paint5_linear_6_18895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43407 28.9418C9.43407 24.5118 12.9543 20.9253 17.2958 20.9253C21.6373 20.9253 25.1575 24.518 25.1575 28.9418C25.1575 33.3655 21.6373 36.9583 17.2958 36.9583C12.9543 36.9583 9.43407 33.3655 9.43407 28.9418Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.82875 27.7984C9.82875 23.5371 13.349 20.0818 17.6905 20.0818C22.0319 20.0818 25.5522 23.5371 25.5522 27.7984C25.5522 32.0596 22.0319 35.5149 17.6905 35.5149C13.349 35.5149 9.82875 32.0596 9.82875 27.7984Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3813 31.4204C23.4198 29.4196 23.4198 26.1755 21.3813 24.1746C19.3428 22.1738 16.0377 22.1738 13.9992 24.1746C11.9607 26.1755 11.9607 29.4196 13.9992 31.4204C16.0377 33.4213 19.3428 33.4213 21.3813 31.4204Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7252 23.1934C27.2264 27.1486 25.2021 33.528 20.2941 34.9838C24.5846 32.6782 26.3034 27.6047 23.8271 23.3184L23.7252 23.1934Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0302 34.3965C7.72168 31.4098 8.79113 22.175 15.7362 20.5817C9.53592 22.9685 8.68927 30.7413 14.0302 34.3965Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4827 27.6609C13.4827 25.3803 15.367 23.5308 17.6905 23.5308C20.014 23.5308 21.8983 25.3803 21.8983 27.6609C21.8983 29.9415 20.014 31.791 17.6905 31.791C15.367 31.791 13.4827 29.9415 13.4827 27.6609Z",
    fill: "url(#paint6_linear_6_18895)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_18895",
    x1: 55.3313,
    y1: 31.791,
    x2: 55.3313,
    y2: 23.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_18895",
    x1: 46.05,
    y1: 46.187,
    x2: 46.05,
    y2: 37.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_18895",
    x1: 26.6981,
    y1: 46.187,
    x2: 26.6981,
    y2: 37.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_18895",
    x1: 36.5141,
    y1: -0.0000156034,
    x2: 36.5141,
    y2: -0.0000156034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_18895",
    x1: 26.8317,
    y1: 16.0955,
    x2: 26.8317,
    y2: 10.3471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_18895",
    x1: 46.2601,
    y1: 16.0955,
    x2: 46.2601,
    y2: 10.3471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_18895",
    x1: 17.6905,
    y1: -0.0000156034,
    x2: 17.6905,
    y2: -0.0000156034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_18895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptPlug);
export default __webpack_public_path__ + "static/media/gpt_plug.209850ed9de19385daf1b5058368f565.svg";
export { ForwardRef as ReactComponent };